import React from "react";

import DeliverTo from "../../../../../components/Restaurants/DeliverTo";
import DeliverIn from "../../../../../components/Restaurants/DeliverIn";
import SortBy from "../../../../../components/Restaurants/SortBy";

const DesktopSearchBar = ({
  preOrderStart,
  preOrderEnd,
  query,
  capitalizeFirstLetter,
  orderBy,
  handleChangeQuery,
  handleKeyUp,
  handleCloseSearchBar,
  handleSearchBar,
  submitFilter
}) => (
  <div className="hide-xs">
    <div className="rest-breadcrumb white-bg" id="search-div">
      <div className="left-gray">
        <div id="left-gray" />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-sm-5 col-md-4 left">
            <div className="d-flex align-items-center">
              <a href="javascript: void(0)" className="margin deliver-to">
                <p>Deliver to: </p>
                <p className="d-flex align-items-center">
                  <DeliverTo route="list" />
                </p>
              </a>

              <a href="javascript:void(0)" className="deliver-in">
                <p>Deliver in:</p>
                <p className="d-flex justify-content-between align-items-center">
                  <DeliverIn
                    preOrderStart={preOrderStart}
                    preOrderEnd={preOrderEnd}
                  />
                </p>
              </a>
            </div>
          </div>
          <div
            id="right"
            className="col-sm-7 col-md-8 right d-flex align-items-center"
          >
            <div className={`form`}>
              <input
                type="text"
                className="form-input"
                placeholder={
                  (query && capitalizeFirstLetter(query)) ||
                  "Search (Cuisines or restaurants)"
                }
                onBlur={handleCloseSearchBar}
                onFocus={handleSearchBar}
                onKeyUp={handleKeyUp}
                onChange={handleChangeQuery}
              />
              <i className="icon icon-search-gray" />
            </div>
            <div className="short-by-dropdown">
              <a href="javascript:void(0)">
                <SortBy onSelectItem={submitFilter} selectedOrderBy={orderBy} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DesktopSearchBar;
